export default __webpack_public_path__ + "static/media/shallow_well_injection.7c39f2f8.png";